import React, { useState, useEffect, useRef } from "react";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { RiImageAddFill } from "react-icons/ri";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { uploadImage } from "../../../CommonComponents/ImageUpload";
import { MagnifyImage } from "../../../CommonComponents/MagnifyImage";

function AddBanner() {

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');
    const navigate = useNavigate();

    const [title, setTitle] = useState();
    const [bannerTypeEnum, setBannerTypeEnum] = useState();
    const [imagePreviews, setImagePreviews] = useState([]); // Array for storing image previews
    const [bannerVideoUrl, setBannerVideoUrl] = useState();
    const [onclickRedirectUrl, setOnclickRedirectUrl] = useState();

    const [isRedirectUrl, setIsRedirectUrl] = useState(true);
    const [isVideoUrl, setIsVideoUrl] = useState(false);
    const selectUrl = (url) => {
        if (url === "redirect") {
            setIsVideoUrl(false);
            setIsRedirectUrl(true);
        } else if (url === "video") {
            setIsRedirectUrl(false);
            setIsVideoUrl(true);
        }
    };

    const content = {
        title: title,
        bannerTypeEnum: bannerTypeEnum,
        ...(isRedirectUrl && { bannerImageUrl: String(imagePreviews?.[0]) }),
        ...(isRedirectUrl && { onclickRedirectUrl: onclickRedirectUrl }),
        ...(isVideoUrl && { bannerVideoUrl: bannerVideoUrl }),
    }

    const members = async (okId) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/banner/create`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                if (okId === 'ok') {
                    navToCat('/admin/banner');
                    setShowPop(false);
                } else if (okId === 'addMore') {
                    setShowPop(false);
                    setTitle('');
                    setBannerTypeEnum('');
                    setOnclickRedirectUrl('');
                    setImagePreviews('');
                    setBannerVideoUrl('');
                    document.getElementById('category-icon').value = null
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
                    });
                };

            } else {
                setShowPop(true);
                setAction('something went wrong');
                setNavv();
                setMore();
                setMore("ok");
            }
        } catch (e) {
            console.log(e, 'error in member api')
        }
    };

    const [showPop, setShowPop] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();

    const [extraBtn, setExtraBtn] = useState();

    const onMoreBtn = () => {
        setShowPop(false);
        members("addMore");
        setNavv();
    };

    const navToCat = useNavigate();
    const confirmPopUp = () => {
        setShowPop(false);
        members("ok");
        setNavv("ok");
    };

    const onCloseBtn = () => {
        setAction('');
        setExtraBtn();
        setMore('cancel');
        setShowPop(false);
    };


    // HANDLE IMAGE SECTION
    const [loading, setLoading] = useState(false);

    const handleFileChange = async (e) => {
        setLoading(true);
        try {
            const files = e.target.files;
            const uploadedUrls = [];
            for (const file of files) {
                const imageUrl = await uploadImage(file);
                if (imageUrl) {
                    uploadedUrls.push(imageUrl.responsePacket);
                };
            };
            setImagePreviews(uploadedUrls);
        } catch (e) {
            console.log("Error during image upload:", e)
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteImage = (index) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this item?");
        if (confirmDelete) {
            const newPreviews = imagePreviews.filter((_, i) => i !== index);
            setImagePreviews(newPreviews); // Update previews
            document.getElementById('category-icon').value = null
        };
    };

    const [showBannerType, setShowBannerType] = useState(false);
    const [typeOfbanner, setTypeOfBanner] = useState([
        { titel: "DashboardTop" }
    ]);
    const [filterTypeOfBanner, setFilterTypeOfBanner] = useState([...typeOfbanner]);

    const searchBannerType = (e) => {
        const res = typeOfbanner.filter((itm) => itm.titel.toLowerCase().includes(e.toLowerCase()));
        setFilterTypeOfBanner(res);
        setShowBannerType(true);
    };

    const selectBanner = (value) => {
        setBannerTypeEnum(value.titel);
        setShowBannerType(false);
        setFilterTypeOfBanner(typeOfbanner);
    };

    const dashRef = useRef();

    useEffect(() => {
        const handleCLick = (event) => {
            if (!dashRef.current?.contains(event.target)) {
                setShowBannerType(false);
            }
        }
        document.addEventListener("mousedown", handleCLick);
    }, [dashRef]);

    // Image Magifinify
    const [imgUrl, setImgUrl] = useState();
    const [showImg, setShowImg] = useState(false);
    const maginifyImage = (e) => {
        setShowImg(true);
        setImgUrl(e);
    };

    const [errors, setErrors] = useState({});
    const titleRef = useRef(null);
    const bannerEnmRef = useRef(null);
    const imageRef = useRef(null);
    const urlRef = useRef(null);

    const handleValidation = () => {
        let newErrors = {};

        if (!title?.trim()) newErrors.title = "titel is required";
        if (!bannerTypeEnum?.trim()) newErrors.bannerTypeEnum = "titel is required";
        // if (!onclickRedirectUrl?.trim()) newErrors.onclickRedirectUrl = "titel is required";
        // if (imagePreviews?.length === 0) newErrors.imagePreviews = "titel is required";

        setErrors(newErrors);

        // If there are errors, scroll to the first one
        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        }

        return true;

    };

    const scrollToField = (field) => {
        switch (field) {
            case "title":
                titleRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "bannerTypeEnum":
                bannerEnmRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            // case "imagePreviews":
            //     imageRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
            //     break;
            // case "onclickRedirectUrl":
            //     urlRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
            //     break;
            default:
                break;
        }
    };

    const handleSubmit = () => {
        handleValidation();
        if (handleValidation()) {
            setAction("Confirm submit");
            setShowPop(true);
            setNavv("OK");
            setExtraBtn("Add More");
            setMore("Cancel")
        }
    };


    // 3. header mobile no. email !!
    // 4. null social media !!!
    // 9. footer logo to top !!!
    // 14. onclink on near !!!
    // 7. staff login sir side
    // 5. setting base url remove !!!
    // 11. banner add handle !!!
    // 6. otp box in line not in box customer side !!!!!!!
    // 12. shipping --x-- amout , disvalue, amount- dropdown !!
    // 10. submit button on top ---- is me phir mouse se click krna pdega !!
    // 8. cart icon!!

    // 15. Image upload !!! --- sir i tried but haven't get an issue 

    // 13. pages pop up design --- farman



    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Add Banner</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">
                        <div className="add-form">

                            {/* NAME*/}
                            <div className="d-flex w-100 m-b2 d-other" ref={titleRef}>
                                <div className="add">
                                    <label style={errors.title && { color: "red" }}>Title</label>
                                    <input
                                        type="text"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />

                                </div>
                                <div className="add parentid" ref={bannerEnmRef}>
                                    <label style={errors.bannerTypeEnum && { color: "red" }}>Banner Type</label>
                                    <input
                                        type="text"
                                        value={bannerTypeEnum}
                                        onChange={(e) => { setBannerTypeEnum(e.target.value); searchBannerType(e.target.value) }}
                                        onClick={() => setShowBannerType(!showBannerType)}
                                    />
                                    {
                                        showBannerType &&
                                        <div className="multiple-cat" ref={dashRef}>
                                            {
                                                filterTypeOfBanner.map((itm, index) => {
                                                    return (
                                                        <>
                                                            <div className="options" key={index}>
                                                                <li onClick={() => { selectBanner(itm) }}>
                                                                    <p>{itm.titel}</p>
                                                                </li>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            }
                                        </div>
                                    }

                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other" ref={titleRef}>
                                <div className="add d-flex">
                                    <input type="radio" name="url" id="redirectUrl" checked={isRedirectUrl} onChange={() => selectUrl("redirect")} />
                                    <label htmlFor="redirectUrl">Redirect Url</label>
                                </div>
                                <div className="add d-flex">
                                    <input type="radio" name="url" id="videoUrl" checked={isVideoUrl} onChange={() => selectUrl("video")} />
                                    <label htmlFor="videoUrl">Video Url</label>
                                </div>
                            </div>

                            {isRedirectUrl && <div className="d-flex w-100 m-b2 d-other" ref={urlRef}>
                                <div className="add w-100" >
                                    <label style={errors.onclickRedirectUrl && { color: "red" }}>Redirect Url</label>
                                    <input
                                        type="text"
                                        value={onclickRedirectUrl}
                                        onChange={(e) => setOnclickRedirectUrl(e.target.value)}
                                    />
                                </div>
                            </div>}

                            {isVideoUrl && <div className="d-flex w-100 m-b2 d-other" ref={urlRef}>
                                <div className="add w-100">
                                    <label style={errors.onclickRedirectUrl && { color: "red" }}>Youtube Video Url</label>
                                    <input
                                        type="text"
                                        value={bannerVideoUrl}
                                        onChange={(e) => setBannerVideoUrl(e.target.value)}
                                    />
                                </div>
                            </div>}


                            {/* Category Icon File Upload */}
                            {isRedirectUrl && <div className="add w-100" ref={imageRef}>
                                <label style={errors.imagePreviews && { color: "red" }}>Image</label>
                                {/* Input Section */}
                                <div className="input-img">
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        // multiple
                                        id="category-icon"
                                        style={{ display: 'none' }} // Hide the actual file input
                                    />
                                    {
                                        imagePreviews?.length > 0 ?
                                            (loading ?
                                                <div className="loading-container">
                                                    <div className="spinner"></div>
                                                    <p>Loading...</p>
                                                </div>
                                                :
                                                <label htmlFor="category-icon" tabIndex="0"
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            document.getElementById("category-icon").click();
                                                        }
                                                    }}>
                                                    <div className="custom-label">
                                                        <RiImageAddFill />
                                                        <span>Change Banner</span>
                                                    </div>
                                                </label>
                                            )
                                            :
                                            (
                                                loading ?
                                                    <div className="loading-container">
                                                        <div className="spinner"></div>
                                                        <p>Loading...</p>
                                                    </div>
                                                    :
                                                    <label htmlFor="category-icon" className="custom-file-input" tabIndex="0"
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                document.getElementById("category-icon").click();
                                                            }
                                                        }}>
                                                        <div className="text">
                                                            <div className="icon">
                                                                <h1><IoCloudUploadOutline /></h1>
                                                                <h4>Add Images</h4>
                                                            </div>
                                                        </div>
                                                    </label>
                                            )
                                    }

                                </div>

                                {/* Image Preview Section */}
                                {
                                    imagePreviews?.length > 0 && !loading && <div className="image-preview-wrapper">
                                        {
                                            imagePreviews?.map((preview, index) => (
                                                <div key={index} className="image-preview-container">
                                                    <img
                                                        src={preview}
                                                        alt={`Category Icon ${index + 1}`}
                                                        style={{ objectFit: 'cover' }}
                                                        onClick={() => maginifyImage(preview)}
                                                        loading="lazy"
                                                    />
                                                    {/* Delete Button */}
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteImage(index)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '0px',
                                                            left: '1px',
                                                            background: 'red',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                            width: '25px',
                                                            height: '25px',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        X
                                                    </button>
                                                </div>
                                            ))}
                                    </div>
                                }
                            </div>}

                        </div>
                    <div className="btn submit-btn" style={{ justifyContent: "flex-start" }}>
                        <button onClick={handleSubmit}>Submit</button>
                    </div>
                    </div>
                </div>
            </div>

            <SuccessPopUp
                isOpen={showPop}
                action={action}
                navv={navv}
                FutherMore={more}
                onClose={onCloseBtn}
                onConfirm={confirmPopUp}
                moreBtn={extraBtn}
                onMoreBtn={onMoreBtn}
            />
            <MagnifyImage isOpen={showImg} imgSrc={imgUrl} onClose={() => setShowImg(false)} />
        </>
    )
}
export default AddBanner;